module.exports = __webpack_public_path__ + "static/media/组 31.c99c04f8.png";